/*eslint-disable */
const environmentconfigData = !process?.env || process.env.NODE_ENV === "development" ? null : environmentConfig;
/*eslint-enable*/
const config = {
  host: environmentconfigData?.host || "public_api_1",
  port: (environmentconfigData && environmentconfigData?.port) || 5007,
  sessionTimeout: (environmentconfigData && environmentconfigData?.sessionTimeout) || 86400000,
  scheme: (environmentconfigData && environmentconfigData?.scheme) || "http",
  defaultCountyCode: (environmentconfigData && environmentconfigData?.defaultCountyCode) || "US",
  ADMIN: {
    apiHost: (environmentconfigData && environmentconfigData?.ADMIN?.apiHost) || "http://admin_api_1:5001",
    apiPath: (environmentconfigData && environmentconfigData?.ADMIN?.apiPath) || "/api",
  },
  GEO: {
    apiHost:
      (environmentconfigData && environmentconfigData?.GEO?.apiHost) || "https://qjumpers-geonames.qa.qjumpers.com",
    apiPath: (environmentconfigData && environmentconfigData?.GEO?.apiPath) || "/api",
  },
  PUBLIC: {
    apiHost: (environmentconfigData && environmentconfigData?.PUBLIC?.apiHost) || "http://public_api_1:5007",
    apiPath: (environmentconfigData && environmentconfigData?.PUBLIC?.apiPath) || "/api",
  },
  app: {
    title: "QJumpers",
    website: "http://qjumpers.com",
    helpline: "0800 758 673",
    description: "QJumpers Recruitment",
    head: {
      titleTemplate: "%s - QJumpers",
      meta: [
        { name: "description", content: "QJumpers Recruitment" },
        { charset: "utf-8" },
        { property: "og:site_name", content: "QJumpers Recruitment" },
        { property: "og:image", content: "" },
        { property: "og:locale", content: "en_US" },
        { property: "og:title", content: "QJumpers Recruitment" },
        { property: "og:description", content: "QJumpers Recruitment" },
        { property: "og:card", content: "summary" },
        { property: "og:site", content: "@QJumpers" },
        { property: "og:creator", content: "QJumpers" },
        { property: "og:image:width", content: "200" },
        { property: "og:image:height", content: "200" },
      ],
    },
  },
};

export default config;
